import React from "react";
import "./ECADIntegration.css";
import ECADIntegrationOverview from "./ECADIntegrationOverview";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import { NavLink } from "react-router-dom";
import BannerImage from "../../../assets/other_image/intigretion.jpg";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
const ECADIntegration = () => {
  return (
    <section className="ECADIntegration-management">
  
       <Banner
        image={BannerImage} // Pass the image for this page
        heading="ECAD Integration with Teamcenter" // Pass the heading text for this page
      />

      <div>
         <FloatingContactUs />
      </div>
      
      
       <ECADIntegrationOverview />
       <div className="Ecad">
        <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
        <h4 className="ECADIntegration-page-heading">Unlock the Power :</h4>
        <h5 className="ECADIntegration-subheading">
          Discover the Transformative Benefits of ECAD Integration with NexTech!
        </h5>
        <ul className="custom-bullets">
          <li>Associative development of mechanical, electrical, electronic, and embedded software technologies. </li>
          <li>Efficient management of Mechatronics data files that support complete design through- the manufacturing process. </li>
          <li>
          Consistent work processes across all data formats. 
          </li>
          <li>Elimination of late discovery of cross-domain integration issues. </li>
        </ul>
      </div>
      </section>

      <section>
  <div className="solutions container">
    <div className="solutions-content">
      <div className="row">
        <div className="col-md-6 col-12">
          <h4 className="ECADIntegration-page-heading">Solutions</h4>
 <p className="plmimplementationparagraph"></p>
          <ul className="custom-bullets">
         <li>Implementation of Teamcenter Gateway for EDA </li>
          <li>Integration of ECAD part libraries </li>
          <li>Seamless integration of ECAD designs </li>
          <li>2TIER & 4TIER integration and configuration of various tools like Clear Case, Mentor, Cadence, Mentor Capital Harness, Zuken, Matlab, and Simulink. </li>
     
          </ul>
  <p className="plmimplementationparagraph">These services enable efficient mapping of business requirements in Teamcenter, ensuring optimal configuration and integration of electronic design, software lifecycle, system engineering, and wire harness management tools for enhanced productivity and streamlined workflows. </p>
        </div>

        <div className="col-md-6 col-12">
          <div className="quick-links">
            <h4>Quick Links</h4>
            <ul>
            <li><NavLink to={"/teamcenter/mcad-integration"} >MCAD Integration</NavLink></li>
            <li><NavLink to={"/teamcenter/cybersecurity"} >Teamcenter Cyber security</NavLink></li>
            <li><NavLink to={"/teamcenter/manufacturing-data-process-management"} >Manufacturing Data and Process Management</NavLink></li>
            <li><NavLink to={"/teamcenter/implementation"} >Teamcenter Implementation</NavLink></li>
             
              <li><NavLink to={"/teamcenter/cae-integration"} >Teamcenter Integration for CAE
              </NavLink></li>
              <li><NavLink to={"/teamcenter/cam-integration"} >Teamcenter Integration for CAM
              </NavLink></li>
              <li><NavLink to={"/teamcenter/upgrade-migration"} >Teamcenter Upgrade & Migration
              </NavLink></li>
              <li><NavLink to={"/teamcenter/aw-client"} >Implementation of Teamcenter AW Client
              </NavLink></li>
             
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


      <section style={{ background: "#f5f7fa" }}>
      <div className="best-practices container">
        <h4 className="ECADIntegration-page-heading">Best Practices</h4>
        <p className="plmimplementationparagraph">
        We help you to enable best practices while performing various activities in manage mode environments on Clear case, Mentor, Cadence, Mentor Capital Harness, Zuken, Matlab, Simulink etc. like electronic component BOM management, defining dependencies between electronic control units and software(source code), establishing relation between functions, requirements, logical design and  networks and  product configuration & visualization of data etc. 
        </p>
        <h5 className="performance-tuning">Performance Tuning:</h5>
        <p className="plmimplementationparagraph"> We ensure right performance tuning by rightly configuring the OS, Hardware, Server & Client system component which help you get right performance while performing various activities in manage mode. </p>
        </div>
      </section>

      <section>
      <div className="why-nextech container">
        <h4 className="ECADIntegration-page-heading">Why NexTech?</h4>
        <h5 className="ECADIntegration-subheading">For  ECAD Integration Solution</h5>
        <ul className="custom-bullets">
          <li>
          Seamless integration of mechanical, electrical, electronic, and embedded software technologies, enabling associative development and cohesive collaboration across domains. 
          </li>
          <li>
          Efficient management of Mechatronics data files throughout the design-to-manufacturing process, ensuring comprehensive control and visibility. 
          </li>
          <li>
          Consistent work processes across all data formats, facilitating streamlined operations and eliminating inconsistencies. 
          </li>
          <li>
          Early detection and resolution of cross-domain integration issues, preventing costly delays and rework during the product development lifecycle. </li>
          <li>
          Expertise in providing integration solutions such as Teamcenter Gateway for EDA, ECAD part library integration, ECAD design integration, and 2TIER & 4TIER integration, ensuring seamless connectivity and data synchronization between diverse tools and platforms. 
          </li>
        </ul>
      </div>
      </section>
      </div>
      <Letsgetintouch />

    </section>
  );
};

export default ECADIntegration;
